module.exports = __webpack_public_path__ + "static/img/app1.0f706fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/works/app1.png
// module id = FSPW
// module chunks = 0